import ComplianceEstLayout from './ComplianceEstLayout';

export default ComplianceEstLayout;
